import React from 'react';

/**
 * Props that make a non-interactive element behave like a button for keyboard and
 * assistive-tech users.
 *
 * Several POS surfaces hang onClick on a plain <div> or <h5> for layout reasons. That
 * leaves the action reachable only by mouse: no tab stop, no Enter/Space, and nothing
 * announcing it as actionable. Spreading this restores all three without changing the
 * element or its styling.
 */
export function clickable(onActivate: () => void) {
  return {
    role: 'button',
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: (event: React.KeyboardEvent) => {
      // The two keys a native button responds to. Space scrolls the page by default,
      // so it has to be suppressed.
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        onActivate();
      }
    },
  };
}
